(function () {
  angular.module('binky.core.feature', ['binky.core.lodash', 'binky.core.src2-migration']);
})();
